import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

class InfoCardList extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired
    };

    constructor (props) {
        super(props);
    }

    render () {
        const { classes, children } =this.props;
        return (
            <div className={classes.root}>
                {children}
            </div>
        );
    }
}

const style = theme => ({

    root: {
        display: 'flex',
        '&> *': {
            flex: '1 1 0',
            '&:not(:last-child)': {
                marginRight: theme.constants.horizontalMargin
            }
        }
    }
});

export default withStyles(style)(InfoCardList);